import { ECPDEntrySource, type TCPDDraftSource } from 'shared/types/redux/cpd';
import { ETabs } from 'shared/types/redux/tabs';

export function getCPDDraftSourceByCurrentTab(currentTab: ETabs, source: ECPDEntrySource): TCPDDraftSource | null {
  const sourceSuffix = source === ECPDEntrySource.Modal ? 'Popup' : 'Banner';

  if (currentTab === ETabs.Agencies) {
    return `trapListingAgencies${sourceSuffix}`;
  }

  if (currentTab === ETabs.Realtors) {
    return `trapListingAgents${sourceSuffix}`;
  }

  return null;
}
